import {RawDraftContentBlock} from 'draft-js';

export const getConcatCommentText = (comment: string) => JSON.parse(comment).blocks
    .reduce((text: string, block: RawDraftContentBlock) =>
        (block.text ? `${text} ${block.text.trim()}` : text), '');
